export enum SessionStorageKeys {
  VoiceAIInsightsFilter = "VoiceAIInsightsFilter",
}
